import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import UserAvatar from '../auth/UserAvatar';
import AdminPermissionSwitch from '../access/AdminPermissionSwitch';
import './Header.css';

interface Feature {
  id: string;
  name: string;
  route: string;
  icon: string;
  description: string;
}

interface HeaderProps {
  title?: string;
  features?: Feature[];
}

const Header: React.FC<HeaderProps> = ({
  title = "Profiler",
  features = []
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleNavClick = (route: string) => {
    navigate(route);
    setMobileMenuOpen(false);
  };

  return (
    <div className="header">
      <div className="brand" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
        <img src="/SSI_logo.png" alt="SSI Strategy" className="ssi-logo" />
        <div className="app-title">{title}</div>
      </div>

      {/* Feature Navigation - Desktop */}
      <div className="header-nav desktop-nav">
        {features.map((feature, index) => (
          <React.Fragment key={feature.id}>
            {index > 0 && <div className="nav-divider">|</div>}
            <button
              className={`nav-link ${location.pathname === feature.route ? 'active' : ''}`}
              onClick={() => navigate(feature.route)}
              title={feature.description}
            >
              <span className="material-icons">{feature.icon}</span>
              <span>{feature.name}</span>
            </button>
          </React.Fragment>
        ))}
      </div>

      <div className="header-right">
        <AdminPermissionSwitch />
        <UserAvatar />

        {/* Hamburger Menu Button - Mobile Only */}
        <button
          className="hamburger-menu"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <span className="material-icons">
            {mobileMenuOpen ? 'close' : 'menu'}
          </span>
        </button>
      </div>

      {/* Mobile Menu Dropdown */}
      {mobileMenuOpen && (
        <div className="mobile-nav-menu">
          {features.map((feature) => (
            <button
              key={feature.id}
              className={`mobile-nav-link ${location.pathname === feature.route ? 'active' : ''}`}
              onClick={() => handleNavClick(feature.route)}
            >
              <span className="material-icons">{feature.icon}</span>
              <div>
                <div className="mobile-nav-name">{feature.name}</div>
                <div className="mobile-nav-desc">{feature.description}</div>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default Header;
